import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fefdfb' },
    '2': { value: '#fefbe9' },
    '3': { value: '#fff7c2' },
    '4': { value: '#ffee9c' },
    '5': { value: '#fbe577' },
    '6': { value: '#f3d673' },
    '7': { value: '#e9c162' },
    '8': { value: '#e2a336' },
    '9': { value: '#ffc53d' },
    '10': { value: '#ffba18' },
    '11': { value: '#ab6400' },
    '12': { value: '#4f3422' },
    a1: { value: '#c0800004' },
    a2: { value: '#f4d10016' },
    a3: { value: '#ffde003d' },
    a4: { value: '#ffd40063' },
    a5: { value: '#f8cf0088' },
    a6: { value: '#eab5008c' },
    a7: { value: '#dc9b009d' },
    a8: { value: '#da8a00c9' },
    a9: { value: '#ffb300c2' },
    a10: { value: '#ffb300e7' },
    a11: { value: '#ab6400' },
    a12: { value: '#341500dd' },
  },
  dark: {
    '1': { value: '#16120c' },
    '2': { value: '#1d180f' },
    '3': { value: '#302008' },
    '4': { value: '#3f2700' },
    '5': { value: '#4d3000' },
    '6': { value: '#5c3d05' },
    '7': { value: '#714f19' },
    '8': { value: '#8f6424' },
    '9': { value: '#ffc53d' },
    '10': { value: '#ffd60a' },
    '11': { value: '#ffca16' },
    '12': { value: '#ffe7b3' },
    a1: { value: '#e63c0006' },
    a2: { value: '#fd9b000d' },
    a3: { value: '#fa820022' },
    a4: { value: '#fc820032' },
    a5: { value: '#fd8b0041' },
    a6: { value: '#fd9b0051' },
    a7: { value: '#ffab2567' },
    a8: { value: '#ffae3587' },
    a9: { value: '#ffc53d' },
    a10: { value: '#ffd60a' },
    a11: { value: '#ffca16' },
    a12: { value: '#ffe7b3' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.amber.light.1}', _dark: '{colors.amber.dark.1}' } },
  '2': { value: { _light: '{colors.amber.light.2}', _dark: '{colors.amber.dark.2}' } },
  '3': { value: { _light: '{colors.amber.light.3}', _dark: '{colors.amber.dark.3}' } },
  '4': { value: { _light: '{colors.amber.light.4}', _dark: '{colors.amber.dark.4}' } },
  '5': { value: { _light: '{colors.amber.light.5}', _dark: '{colors.amber.dark.5}' } },
  '6': { value: { _light: '{colors.amber.light.6}', _dark: '{colors.amber.dark.6}' } },
  '7': { value: { _light: '{colors.amber.light.7}', _dark: '{colors.amber.dark.7}' } },
  '8': { value: { _light: '{colors.amber.light.8}', _dark: '{colors.amber.dark.8}' } },
  '9': { value: { _light: '{colors.amber.light.9}', _dark: '{colors.amber.dark.9}' } },
  '10': { value: { _light: '{colors.amber.light.10}', _dark: '{colors.amber.dark.10}' } },
  '11': { value: { _light: '{colors.amber.light.11}', _dark: '{colors.amber.dark.11}' } },
  '12': { value: { _light: '{colors.amber.light.12}', _dark: '{colors.amber.dark.12}' } },
  a1: { value: { _light: '{colors.amber.light.a1}', _dark: '{colors.amber.dark.a1}' } },
  a2: { value: { _light: '{colors.amber.light.a2}', _dark: '{colors.amber.dark.a2}' } },
  a3: { value: { _light: '{colors.amber.light.a3}', _dark: '{colors.amber.dark.a3}' } },
  a4: { value: { _light: '{colors.amber.light.a4}', _dark: '{colors.amber.dark.a4}' } },
  a5: { value: { _light: '{colors.amber.light.a5}', _dark: '{colors.amber.dark.a5}' } },
  a6: { value: { _light: '{colors.amber.light.a6}', _dark: '{colors.amber.dark.a6}' } },
  a7: { value: { _light: '{colors.amber.light.a7}', _dark: '{colors.amber.dark.a7}' } },
  a8: { value: { _light: '{colors.amber.light.a8}', _dark: '{colors.amber.dark.a8}' } },
  a9: { value: { _light: '{colors.amber.light.a9}', _dark: '{colors.amber.dark.a9}' } },
  a10: { value: { _light: '{colors.amber.light.a10}', _dark: '{colors.amber.dark.a10}' } },
  a11: { value: { _light: '{colors.amber.light.a11}', _dark: '{colors.amber.dark.a11}' } },
  a12: { value: { _light: '{colors.amber.light.a12}', _dark: '{colors.amber.dark.a12}' } },
  default: { value: { _light: '{colors.amber.light.9}', _dark: '{colors.amber.dark.9}' } },
  emphasized: { value: { _light: '{colors.amber.light.10}', _dark: '{colors.amber.dark.10}' } },
  fg: { value: { _light: '{colors.gray.light.12}', _dark: '{colors.gray.light.12}' } },
  text: { value: { _light: '{colors.amber.light.a11}', _dark: '{colors.amber.dark.a11}' } },
})

export default {
  name: 'amber',
  tokens,
  semanticTokens,
}
